"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const UI_1 = require("~/components/UI");
const consts_1 = require("~/consts/consts");
const utils_1 = require("~/utils/utils");
const selectors_1 = require("~/store/selectors");
const CatalogTile_module_scss_1 = __importDefault(require("./CatalogTile.module.scss"));
function CatalogTile({ id, imageURI = consts_1.itemPlaceholderSrc, label, value, tooltip, active = false, disabled = false, canBeMitered = true, onClick = () => ({}), }) {
    const { t } = (0, react_i18next_1.useTranslation)('catalog-widget');
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const drawingAngled = (0, react_redux_1.useSelector)(selectors_1.selectDrawingAngled);
    const angledOnButNotSupported = drawingAngled && !canBeMitered;
    const clickHandler = () => {
        if (!disabled && !angledOnButNotSupported) {
            onClick(value);
        }
    };
    const button = (react_1.default.createElement("button", { type: "button", className: CatalogTile_module_scss_1.default.tile, key: `${label}${id}`, onClick: clickHandler, "data-active": active && !disabled && !angledOnButNotSupported, disabled: disabled || angledOnButNotSupported },
        react_1.default.createElement("div", { className: CatalogTile_module_scss_1.default.imageWrapper },
            react_1.default.createElement(UI_1.Image, { className: CatalogTile_module_scss_1.default.image, src: (0, utils_1.formatAssetsURL)(imageURI) })),
        label ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        react_1.default.createElement(react_1.default.Fragment, null, tooltip ? (react_1.default.createElement(UI_1.Tooltip, { contentNode: tooltip.contentNode, placement: tooltip.placement },
            react_1.default.createElement("div", { className: CatalogTile_module_scss_1.default.label }, label))) : (react_1.default.createElement("div", { className: CatalogTile_module_scss_1.default.label }, label)))) : null));
    let content = disabled ? t('there-is-no-CAD-file') : '';
    content = angledOnButNotSupported ? t('can-not-be-mitered') : content;
    return (react_1.default.createElement(UI_1.Tooltip, { className: CatalogTile_module_scss_1.default.tooltip, contentNode: content, placement: "right-start", disabled: (!disabled && !angledOnButNotSupported) || isBOMEditMode },
        react_1.default.createElement("div", null, button)));
}
exports.default = CatalogTile;
